import { API_URL, buildHeaders, handleResponse } from './apiClient';

export const fetchTeams = async (token) => {
  const response = await fetch(`${API_URL}/teams`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente team.');
};

export const fetchTeam = async (id, token) => {
  const response = await fetch(`${API_URL}/teams/${id}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente team.');
};

export const createTeam = async (teamData, token) => {
  const response = await fetch(`${API_URL}/teams`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify(teamData),
  });
  return handleResponse(response, 'Kunne ikke opprette team.');
};

export const updateTeam = async (id, teamData, token) => {
  const response = await fetch(`${API_URL}/teams/${id}`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify(teamData),
  });
  return handleResponse(response, 'Kunne ikke oppdatere team.');
};

export const deleteTeam = async (id, token) => {
  const response = await fetch(`${API_URL}/teams/${id}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke slette team.');
};

export const fetchMyTeams = async (token) => {
  const response = await fetch(`${API_URL}/teams/my-teams`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente dine team.');
};

export const fetchTeamsForEmployee = async (employeeId, token) => {
  const response = await fetch(`${API_URL}/teams/employee/${employeeId}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente team for ansatt.');
};

// Get teams for a specific user (admin only - for "view as user" feature)
export const fetchTeamsForUser = async (userId, token) => {
  const response = await fetch(`${API_URL}/teams/user/${userId}`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente team for bruker.');
};

// Team members
export const fetchTeamMembers = async (teamId, token) => {
  const response = await fetch(`${API_URL}/teams/${teamId}/members`, {
    method: 'GET',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente teammedlemmer.');
};

export const addTeamMember = async (teamId, employeeId, token) => {
  const response = await fetch(`${API_URL}/teams/${teamId}/members`, {
    method: 'POST',
    headers: buildHeaders(token),
    body: JSON.stringify({ employeeId }),
  });
  return handleResponse(response, 'Kunne ikke legge til medlem.');
};

export const removeTeamMember = async (teamId, employeeId, token) => {
  const response = await fetch(`${API_URL}/teams/${teamId}/members/${employeeId}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke fjerne medlem.');
};
